import React, { useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";
import { dateByResponsable, filterData } from "../../api/common";

ChartJS.register(ArcElement, Tooltip, Legend);

export function  ItemsByResponsable({startDate, endDate}) {

  const [responsable, setResponsable] = useState("");
  const [responsablesList, setResponsablesList] = useState([]);
  const [chartData, setChartData] = useState(null);

  const fetchData = async () => {

    if (!startDate || !endDate || !responsable) return;
    try {
      const res = await dateByResponsable('dashboard',{
        fechaInicio:startDate,
        fechaFin: endDate,
        responsable:responsable
      });
      const data = res.data
      // Esperando respuesta tipo:
      // [{ _id: "Revisión", total: 51 }, { _id: "Abiertas", total: 32 }, ...]
      const labels = data.map(item => item._id);
      const values = data.map(item => item.total);

      setChartData({
        labels,
        datasets: [
          {
            data: values,
            backgroundColor: [
              "#36A2EB", // puedes personalizar si quieres
              "#4BC0C0",
              "#FFCE56",
              "#FF6384",
              "#9966FF",
              "#FF9F40",
              "#C9CBCF",
            ],
          },
        ],
      });
    } catch (err) {
      console.error("Error cargando datos:", err);
    }
  };

    // Traer responsables al cargar
    useEffect(() => {
     const fetchResponsables = async () => {
        const clientesDB = await filterData("usuarios",[ // Body para la consuta aggregate de mongo para metrologos y que esten activos.
                  {
                    "$match": {
                      'status': 'activo'
                    } 
                  },
                  {
                    "$lookup": {
                      "from": "roles",
                      "localField": "role",
                      "foreignField": "_id",
                      "as": "result"
                    }
                  },
                  {
                    "$match": {
                      "result.nombre":"Metrologo"
                    }
                  }
                ]);
        
                   const cl = clientesDB.data.data.map((client)=>({
                    value:client._id,
                    label:client.nombre + " "+ client.apellido ,
                }));

        setResponsablesList(clientesDB.data.data);
            // ✅ Seleccionar automáticamente el PRIMERO
        if (cl.length > 0) {
            setResponsable(cl[0].value);
        }
    }
    fetchResponsables();
    }, []);

  
  useEffect(() => {
    fetchData();
  }, [startDate, endDate, responsable]);

  return (
    <div className="chart-circular-container-main dashboard-item">
      <span className="chart-header">{"Items por Responsable"}</span>

      {/* 🔽 Dropdown de responsables */}
      <div style={{ margin: "1rem" }}>
        <label>Responsable: </label>
        <select
          value={responsable}
          onChange={(e) => setResponsable(e.target.value)}
        >
          <option value="">-- Seleccionar --</option>
          {responsablesList.map((r) => (
            <option key={r._id} value={r._id}>
              {r.nombre+" "+r.apellido} {/* Ajusta nombre/campo real */}
            </option>
          ))}
        </select>
      </div>

      {/* Chart */}
      {chartData ? (
        <Doughnut data={chartData} />
      ) : (
        <p>Selecciona un responsable</p>
      )}
    </div>
  );
};
